module.exports = __webpack_public_path__ + "static/Lua-32ddcb6355967a6db1593188e6cbd718.svg";